export enum AccordionType {
  CLASSIC,
  BORDERLESS_ON_BACKGROUND,
  STANDALONE
}
